<template>
  <div class="flex flex-col sm:flex-row gap-3 mb-6 items-stretch sm:items-center justify-between">
    <!-- Buscador Principal -->
    <div class="relative flex-1">
      <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400">
        <i class="fa fa-search text-sm" />
      </div>
      <input 
        :value="search"
        type="text"
        class="block w-full pl-10 pr-10 py-2.5 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 placeholder-gray-400 transition-all shadow-sm text-sm" 
        placeholder="Buscar producto por código, nombre o descripción..." 
        @input="$emit('update:search', $event.target.value)"
      />
      <button 
        v-if="search" 
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
        @click="$emit('update:search', '')"
      >
        <i class="fa fa-times-circle text-sm" />
      </button>
    </div>

    <!-- Quick Type Filter Pills -->
    <div class="flex items-center gap-1.5 overflow-x-auto pb-1 sm:pb-0">
      <button
        type="button"
        class="px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors"
        :class="!typeProduct ? 'bg-orange-500 text-white shadow-xs' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:typeProduct', '')"
      >
        Todos
      </button>
      <button
        type="button"
        class="px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors"
        :class="typeProduct === 'product' ? 'bg-orange-500 text-white shadow-xs' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:typeProduct', 'product')"
      >
        Productos
      </button>
      <button
        type="button"
        class="px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors flex items-center gap-1"
        :class="typeProduct === 'insumo' ? 'bg-amber-500 text-white shadow-xs' : 'bg-white text-amber-700 border border-amber-200 hover:bg-amber-50'"
        @click="$emit('update:typeProduct', 'insumo')"
      >
        <i class="fa fa-boxes-stacked text-[11px]" />
        Insumos
      </button>
      <button
        type="button"
        class="px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors flex items-center gap-1"
        :class="typeProduct === 'recipe' ? 'bg-purple-600 text-white shadow-xs' : 'bg-white text-purple-700 border border-purple-200 hover:bg-purple-50'"
        @click="$emit('update:typeProduct', 'recipe')"
      >
        <i class="fa fa-utensils text-[11px]" />
        Recetas
      </button>
      <button
        type="button"
        class="px-3 py-2 rounded-lg text-xs font-semibold whitespace-nowrap transition-colors"
        :class="typeProduct === 'service' ? 'bg-blue-600 text-white shadow-xs' : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50'"
        @click="$emit('update:typeProduct', 'service')"
      >
        Servicios
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductFilters',

  props: {
    search: {
      type: String,
      default: '',
    },
    typeProduct: {
      type: String,
      default: '',
    },
  },

  emits: ['update:search', 'update:typeProduct'],
}
</script>
